import React from "react";

const Qualification = () => {
  const qualifications = [
    {
      university: "MKCG Medical College & Hospital, Berhampur (Odisha)",
      duration: "",
      degree: "MBBS",
      year: "2008",
    },
    {
      university: "SCB Medical College & Hospital, Cuttack (Odisha)",
      duration: "",
      degree: "MS (Orthopaedics)",
      year: "2012",
    },
    {
      university: "PGIMER, Chandigarh",
      degree: "Senior Residency Orthopaedics",
      year: "2015",
    },
    {
      university:
        "Hallym University Dongtan Sacred Heart Hospital, South Korea",
      duration: "",
      degree: "Bi-Portal Endoscopic Spine Surgery",
      year: "2018",
    },
    {
      university: "Korea University Guro Hospital, Seoul",
      degree: "Fellowship Orthopaedic Trauma",
      year: "2019",
    },
    {
      university: "Stavya Spine Hospital & Research Institute, Ahmedabad",
      degree: "Fellowship Spine Surgery",
      year: "2020",
    },
  ];

  return (
    <section className="qualification-section">
      <div className="container">
        {/* Professional Header */}
        <div className="professional-header">
          <div className="header-line"></div>
          <div className="header-content">
            <span className="section-tag">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2L15 8.5L22 9.5L17 14L18.5 21L12 17.5L5.5 21L7 14L2 9.5L9 8.5L12 2Z"
                  fill="currentColor"
                />
              </svg>
              Academic Excellence
            </span>
            <h2 className="section-title">
              Education, Fellowships & Professional Training
            </h2>
            <p className="section-subtitle">Credentials & Certifications</p>
          </div>
          <div className="header-line"></div>
        </div>

        {/* Timeline Cards */}
        <div className="timeline-wrapper">
          <div className="timeline-line"></div>
          <div className="row g-4">
            {qualifications.map((q, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="professional-card">
                  <div className="card-year-badge">
                    <span>{q.year || "2024"}</span>
                  </div>
                  <div className="card-content">
                    <div className="card-icon">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          fill="none"
                        />
                        <path
                          d="M22 6L12 13L2 6"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          fill="none"
                        />
                        <path
                          d="M2 18L8 12"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M22 18L16 12"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>

                    <div className="card-body-content">
                      <div className="degree-title">{q.degree}</div>
                      <div className="institution-name">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 2L2 7L12 12L22 7L12 2Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            fill="none"
                          />
                          <path
                            d="M2 17L12 22L22 17"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            fill="none"
                          />
                          <path
                            d="M2 12L12 17L22 12"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            fill="none"
                          />
                        </svg>
                        {q.university}
                      </div>
                    </div>

                    <div className="card-connector"></div>
                    <div className="card-shine"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .qualification-section {
          background: white;
          padding-bottom: 2rem;
          position: relative;
          overflow: hidden;
        }

        /* Professional Header */
        .professional-header {
          text-align: center;
          margin-bottom: 60px;
          position: relative;
        }

        .header-line {
          width: 80px;
          height: 2px;
          background: linear-gradient(
            90deg,
            transparent,
            #0d6efd,
            #0d6efd,
            #0d6efd,
            transparent
          );
          margin: 0 auto;
        }

        .header-line:first-child {
          margin-bottom: 20px;
        }

        .header-line:last-child {
          margin-top: 20px;
        }

        .section-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(81, 117, 172, 0.1);
          color: #0d6efd;
          padding: 8px 20px;
          border-radius: 50px;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 1px;
          margin-bottom: 15px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(201, 160, 61, 0.2);
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #1a1a2e;
          margin-bottom: 10px;
          letter-spacing: -0.5px;
        }

        .section-subtitle {
          color: #6c757d;
          font-size: 1rem;
          font-weight: 500;
          letter-spacing: 2px;
          text-transform: uppercase;
        }

        /* Timeline Wrapper */
        .timeline-wrapper {
          position: relative;
        }

        .timeline-line {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 2px;
          height: 100%;

          opacity: 0.3;
        }

        /* Professional Card */
        .professional-card {
          position: relative;
          background: white;
          border-radius: 10px;
          padding: 10px;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          overflow: hidden;
          box-shadow: 0 4px 4px rgba(0, 0, 0, 0.04);
          border: 2px solid rgba(45, 45, 67, 0.1);
        }

        .professional-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #5c7bd2, #14308b, #3d6cc9);
          transform: scaleX(0);
          transition: transform 0.4s ease;
          z-index: 2;
        }

        .professional-card:hover::before {
          transform: scaleX(1);
        }

        .professional-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border-color: rgba(0, 53, 244, 0.2);
        }

        /* Year Badge */
        .card-year-badge {
          position: absolute;
          top: 12px;
          right: 20px;
          background: linear-gradient(135deg, #6784d3, #374ea1, #6984cf);
          color: white;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.5px;
          z-index: 3;
          box-shadow: 0 2px 8px rgba(73, 61, 201, 0.3);
        }

        .card-content {
          padding: 28px 24px 24px 24px;
          position: relative;
          overflow: hidden;
        }

        /* Card Icon */
        .card-icon {
          width: 50px;
          height: 50px;
          background: linear-gradient(
            135deg,
            rgba(61, 105, 201, 0.1),
            rgba(28, 20, 139, 0.05)
          );
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 14px;
          transition: all 0.3s ease;
          color: #33619d;
        }

        .professional-card:hover .card-icon {
          background: linear-gradient(135deg, #e0c483, #fdd87b);
          color: white;
          transform: scale(1.05);
        }

        /* Card Body Content */
        .card-body-content {
          position: relative;
          z-index: 1;
        }

        .degree-title {
          font-size: 20px;
          font-weight: 700;
          color: #1a1a2e;
          margin-bottom: 12px;
          line-height: 1.4;
          letter-spacing: -0.3px;
        }

        .institution-name {
          font-size: 14px;
          color: #4b545c;
          line-height: 1.4;
          display: flex;
          align-items: flex-start;
          gap: 6px;
        }

        .institution-name svg {
          flex-shrink: 0;
          margin-top: 2px;
          color: #d69f1e;
        }

        /* Card Connector */
        .card-connector {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(90deg, transparent, #3d4bc9, transparent);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .professional-card:hover .card-connector {
          opacity: 1;
        }

        /* Card Shine Effect */
        .card-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
          );
          transition: left 0.6s ease;
          pointer-events: none;
        }

        .professional-card:hover .card-shine {
          left: 100%;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .timeline-line {
            display: none;
          }

          .section-title {
            font-size: 2rem;
          }
        }

        @media (max-width: 768px) {
          .qualification-section {
            padding: 60px 0;
          }

          .section-title {
            font-size: 1.75rem;
          }

          .card-content {
            padding: 20px;
          }

          .degree-title {
            font-size: 16px;
          }

          .institution-name {
            font-size: 13px;
          }

          .card-icon {
            width: 48px;
            height: 48px;
          }

          .card-icon svg {
            width: 24px;
            height: 24px;
          }
        }

        @media (max-width: 576px) {
          .section-title {
            font-size: 1.5rem;
          }

          .card-year-badge {
            top: -10px;
            right: 15px;
            font-size: 10px;
            padding: 3px 10px;
          }
        }

        /* Animation for cards */
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .professional-card {
          animation: slideUp 0.6s ease-out forwards;
          opacity: 0;
        }

        .col-md-6:nth-child(1) .professional-card {
          animation-delay: 0.05s;
        }
        .col-md-6:nth-child(2) .professional-card {
          animation-delay: 0.1s;
        }
        .col-md-6:nth-child(3) .professional-card {
          animation-delay: 0.15s;
        }
        .col-md-6:nth-child(4) .professional-card {
          animation-delay: 0.2s;
        }
        .col-md-6:nth-child(5) .professional-card {
          animation-delay: 0.25s;
        }
        .col-md-6:nth-child(6) .professional-card {
          animation-delay: 0.3s;
        }

        /* Custom Scrollbar */
        .qualification-section::-webkit-scrollbar {
          width: 8px;
        }

        .qualification-section::-webkit-scrollbar-track {
          background: #f1f1f1;
        }

        .qualification-section::-webkit-scrollbar-thumb {
          background: #c9a03d;
          border-radius: 4px;
        }

        .qualification-section::-webkit-scrollbar-thumb:hover {
          background: #8b6914;
        }
      `}</style>
    </section>
  );
};

export default Qualification;
